import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
} from "react-bootstrap";

import { AlertInfo } from "../../components/Alert/AlertInfo.jsx";
import { Card } from "../../components/Card/Card.jsx";
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import { NavLink } from "react-router-dom";

import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables.jsx";

import Select from 'react-select';

const restLink_comboHasProduct = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'
 });
const comboHasProduct_client = new ApolloClient({
  link: restLink_comboHasProduct,
  cache: new InMemoryCache(),
});

const ADD_TODO = gql`
  mutation updateComboHasProduct($id: Int!,$combo_id: Int!,$product_id: Int!, $num: Int!){
    createOrUpdateComboHasProduct(id:$id, input:{ combo_id:$combo_id, product_id:$product_id, num:$num}){
      id
    }
  }
`;

const GET_COMBOHASPRODUCT = gql`
  query getComboHasProduct($comboHasProduct_id: Int!){
    comboHasProduct(id:$comboHasProduct_id){
      id
      product{
        value:id
        label:title
      }
      num
    }
  }`;


const GET_PRODUCTS = gql`{
  product_collection{
    products{
      value:id
      label:title
    }
  }
}`;


class ComboHasProductItem extends Component {

  comboHasProduct_id;
  comboHasProduct_edit;
  parent_id;
  back_button;

  state = {
    alertInfo: ""
  };

  constructor() {
    super();

    this.start_is_blocked = true;
    
  }



  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      alertInfo: "Salvo com sucesso!"
    });

    setTimeout(() => {
      this.setState({
        alertInfo: ""
      })
    },3000);
  }

  
  render() {

    
    this.comboHasProduct_id = (this.props.match.params.id ? this.props.match.params.id : 0);


    return (


      <Query
      client={comboHasProduct_client}
      query={GET_COMBOHASPRODUCT}
      variables={{comboHasProduct_id:this.comboHasProduct_id}}
      >
      {({ loading, error, data }) => {
        if (loading) return <div>Carregando...</div>;
        if (error) return <div>Erro :(</div>;
          
          this.comboHasProduct_edit = data.comboHasProduct;

        return (

      <Mutation mutation={ADD_TODO} client={comboHasProduct_client}>
      {(createOrUpdateComboHasProduct, { data }) => (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>

                <a
                  href='javascript:history.go(-1)'
                  className="btn btn-info btn-fill"
                >
                VOLTAR
              </a>
            <NotificationSystem ref="notificationSystem" style={style} />
            
              <Card
                name="Conta"
                content={
                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();

                    createOrUpdateComboHasProduct({variables: { 
                      combo_id: this.props.match.params.combo_id, 
                      id: this.comboHasProduct_id, 
                      product_id: e.target.elements.product_id.value,
                      num: e.target.elements.num.value
                    } });
                  }}
                  >

                  <FormGroup>
                    <ControlLabel>Produto</ControlLabel>
                    <div>
                      <Query
                          client={comboHasProduct_client}
                          query={GET_PRODUCTS}
                          >
                          {({ loading, error, data }) => {
                            if (loading) return <div>Carregando...</div>;
                            if (error) return <div>Erro :(</div>;
                            return (
                              <Select
                                required={true}
                                name="product_id"
                                options={data.product_collection ? data.product_collection.products : []}
                                className="basic-select"
                                classNamePrefix="select"
                                defaultValue={this.comboHasProduct_edit && this.comboHasProduct_edit.product ? this.comboHasProduct_edit.product : ""}
                              />
                              );
                            }}
                      </Query>
                    </div>
                  </FormGroup>

                  <FormInputs
                      ncols={["col-md-12"]}
                      proprieties={[
                        {
                          required: true,
                          name: "num",
                          label: "Quantidade",
                          type: "number",
                          bsClass: "form-control",
                          placeholder: "Quantidade",
                          defaultValue: (this.comboHasProduct_edit && this.comboHasProduct_edit.num ? this.comboHasProduct_edit.num : "")
                        }
                      ]}
                    />

                  
                  <Row>
                    <Col md={10}>
                      <AlertInfo ref="alertSave" alertInfo={this.state.alertInfo} />
                    </Col>
                    <Col md={2}>
                      <Button bsStyle="info" pullRight fill type="submit">
                        Salvar
                      </Button>
                    </Col>
                  </Row>
                    <div className="clearfix" />
                  </form>
                }
              />
              
            </Col>
            
          </Row>
        </Grid>
      </div>
      )}
      </Mutation>

      );
      }}
      </Query>
    );
  }
}

export default ComboHasProductItem;
